import {
  AccountLimitsResponse,
  TopUpLimitResponse,
  UsageLimitResponse,
} from '../responses/responseTypes';

export const transformTopUpLimit = (limit: TopUpLimitResponse): TopUpLimit => ({
  ...limit,
  topUp: limit.top_up ?? null,
});

export const transformAccountLimitsResponse = (
  response: AccountLimitsResponse
): AccountLimits => ({
  usageData: {
    downloadSong: transformTopUpLimit(response.usage_data.download_song),
    downloadStems: transformTopUpLimit(response.usage_data.download_stems),
    downloadSamplePack: transformTopUpLimit(
      response.usage_data.download_sample_pack
    ),
    generateVegaSong: response.usage_data.generate_vega_song,
    exportStudioSong: response.usage_data.export_studio_song,
    submitRelease: response.usage_data.submit_release,
    uploadAudio: response.usage_data.upload_audio,
  },
  resetData: {
    nextResetDate: response.reset_data.next_reset_date,
    resetDate: response.reset_data.reset_date,
    resetInDays: response.reset_data.reset_in_days,
  },
});

export interface AccountLimits {
  usageData: UsageData;
  resetData: {
    nextResetDate: string;
    resetDate: string;
    resetInDays: number;
  };
}

export interface UsageData {
  downloadSong: TopUpLimit;
  downloadStems: TopUpLimit;
  downloadSamplePack: TopUpLimit;
  generateVegaSong: UsageLimitResponse;
  exportStudioSong: UsageLimitResponse;
  submitRelease: UsageLimitResponse;
  uploadAudio: UsageLimitResponse;
}

interface TopUpLimit extends UsageLimitResponse {
  topUp: UsageLimitResponse | null;
}
